import { apiClient } from '@/api/client';
import type { IApiResponse } from '@/api/types';

import type {
    IListNotificationsResponse,
    ISyncResponse,
    IUnreadCounts,
    NotificationType,
} from '../types';

interface IListParams {
    type?: NotificationType;
    unreadOnly?: boolean;
    cursor?: string;
    limit?: number;
}

export const notificationsApi = {
    list: (params: IListParams): Promise<IListNotificationsResponse> =>
        apiClient
            .get<IApiResponse<IListNotificationsResponse>>('/notifications', { params })
            .then((r) => r.data.data),

    unreadCount: (): Promise<IUnreadCounts> =>
        apiClient
            .get<IApiResponse<IUnreadCounts>>('/notifications/unread-count')
            .then((r) => r.data.data),

    markRead: (id: string): Promise<{ id: string }> =>
        apiClient
            .post<IApiResponse<{ id: string }>>(`/notifications/${id}/read`)
            .then((r) => r.data.data),

    markAllRead: (type?: NotificationType): Promise<unknown> =>
        apiClient
            .post<IApiResponse<unknown>>('/notifications/read-all', { type })
            .then((r) => r.data.data),

    sync: (since: string): Promise<ISyncResponse> =>
        apiClient
            .get<IApiResponse<ISyncResponse>>('/notifications/sync', { params: { since } })
            .then((r) => r.data.data),
};
